'use strict';

exports.decode = exports.parse = require('./decode');
exports.encode = exports.stringify = require('./encode');



//////////////////
// WEBPACK FOOTER
// /home/circleci/pickle/~/querystring-es3/index.js
// module id = pjDS
// module chunks = 0